// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const VitaminK2 = {
  productCode: "SBOVZ-GK2-7",
  productName: "Vitamin K2-7 (Menaquinone)",
  ingredients: "Green tea, Soybean",
  overview:"Natural Vitamin K2-7 is a standardized extract blend of organic Soybean as core ingredient and organic green tea as a co-ingredient, naturally fermented that offers vitamin K2-7 along with other co-nutrients of soybean and green tea.",
  assay:"Natural Vitamin K2-7: 250 ppm; Natural Vitamin K2-6 – In traces",
  coNutrients:" Incidental nutrients include EGCG, Flavonoids, Polyphenols and L-theanine.",
  studies:"Comprehensive Stability studies, comparative studies with synthetic sources.",
  benefits:"Putative functions of K2 include a role in sphingolipid synthesis. Essential for Bone Health & Osteoporosis Prevention in postmenopausal women. Synergy with Vitamin D3 helps effective calcium absorption. ",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/VitaminK2/VK2-1.png",
    "images/Portfolio/OrgavitazForDeficiencies/VitaminK2/VK2-2.png",
    "images/Portfolio/OrgavitazForDeficiencies/VitaminK2/VK2-3.png",



  ],
  certificates: [
   "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default VitaminK2;
